export default "__VITE_ASSET__BppQkr35__"